import { FormEvent, memo, ReactNode } from 'react';
import { FormProvider as Form, UseFormReturn } from 'react-hook-form';
import cn from 'classnames';

import s from './FormProvider.module.scss';

interface FormProviderProps {
  children: ReactNode;
  methods: UseFormReturn<any>;
  className?: string;
  onSubmit?: (e: FormEvent<HTMLFormElement>) => void;
}

export const FormProvider = memo(
  ({ children, methods, className, onSubmit }: FormProviderProps) => (
    <Form {...methods}>
      <form className={cn(s.form, className)} onSubmit={onSubmit}>
        {children}
      </form>
    </Form>
  )
);
